import axios from "axios";
import {
  FETCH_PAGE_USER_INFO_LOADING,
  FETCH_PAGE_USER_INFO_SUCCESS,
  FETCH_PAGE_USER_INFO_FAIL,
  FETCH_PAGE_USER_SUMMARY_LOADING,
  FETCH_PAGE_USER_SUMMARY_SUCCESS,
  FETCH_PAGE_USER_SUMMARY_FAIL,
  FETCH_PAGE_USERS_PAGINATED_LOADING,
  FETCH_PAGE_USERS_PAGINATED_SUCCESS,
  FETCH_PAGE_USERS_PAGINATED_FAIL,
  FETCH_PAGE_USER_PHONENAME_LOADING,
  FETCH_PAGE_USER_PHONENAME_SUCCESS,
  FETCH_PAGE_USER_PHONENAME_FAIL,
  FETCH_PAGE_USER_DRINKS_LOADING,
  FETCH_PAGE_USER_DRINKS_SUCCESS,
  FETCH_PAGE_USER_DRINKS_FAIL,
  FETCH_PAGE_USER_CRAFTEDDRINKS_LOADING,
  FETCH_PAGE_USER_CRAFTEDDRINKS_SUCCESS,
  FETCH_PAGE_USER_CRAFTEDDRINKS_FAIL,
  FETCH_PAGE_USER_MYBAR_LOADING,
  FETCH_PAGE_USER_MYBAR_SUCCESS,
  FETCH_PAGE_USER_MYBAR_FAIL,
  FETCH_RECENTLY_MADE_DRINKS_LOADING,
  FETCH_RECENTLY_MADE_DRINKS_SUCCESS,
  FETCH_RECENTLY_MADE_DRINKS_FAIL,
  FETCH_RECENTLY_MOST_REPEATED_DRINKS_LOADING,
  FETCH_MOST_REPEATED_DRINKS_SUCCESS,
  FETCH_MOST_REPEATED_DRINKS_FAIL,
  FETCH_FAVOURITE_DRINKS_LOADING,
  FETCH_FAVOURITE_DRINKS_SUCCESS,
  FETCH_FAVOURITE_DRINKS_FAIL,
  SET_USERS_PAGE_CURRENT,
  SET_USERS_ITEMS_PER_PAGE,
  SET_USERS_SEARCH_TERM,
  SET_USERS_USER_TYPE,
  SET_USERS_DATE_OPTION,
  SET_USERS_AGE_OPTION,
  SET_USERS_CUSTOM_DATE_RANGE,
  SET_USERS_START_DATE,
  SET_USERS_END_DATE,
  FETCH_USER_DEVICES_LOADING,
  FETCH_USER_DEVICES_SUCCESS,
  FETCH_USER_DEVICES_FAIL,
} from "./types";

// Fetch devices for a given userId
export const fetchUserDevices = (userId) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/users/${userId}/devices`;

  dispatch({ type: FETCH_USER_DEVICES_LOADING });
  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const { data } = response;
    if (data.success) {
      dispatch({
        type: FETCH_USER_DEVICES_SUCCESS,
        payload: data,
      });
    } else {
      dispatch({
        type: FETCH_USER_DEVICES_FAIL,
        payload: data.message,
      });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({
      type: FETCH_USER_DEVICES_FAIL,
      payload: errorMessage,
    });
  }
};

//Params state
export const setUsersPageCurrent = (page) => ({
  type: SET_USERS_PAGE_CURRENT,
  payload: page,
});
export const setUsersItemsPerPage = (items) => ({
  type: SET_USERS_ITEMS_PER_PAGE,
  payload: items,
});
export const setUsersSearchTerm = (term) => ({
  type: SET_USERS_SEARCH_TERM,
  payload: term,
});
export const setUsersUserType = (userType) => ({
  type: SET_USERS_USER_TYPE,
  payload: userType,
});
export const setUsersDateOption = (option) => ({
  type: SET_USERS_DATE_OPTION,
  payload: option,
});
export const setUsersAgeOption = (option) => ({
  type: SET_USERS_AGE_OPTION,
  payload: option,
});
export const setUsersCustomDateRange = (value) => ({
  type: SET_USERS_CUSTOM_DATE_RANGE,
  payload: value,
});
export const setUsersStartDate = (date) => ({
  type: SET_USERS_START_DATE,
  payload: date,
});
export const setUsersEndDate = (date) => ({
  type: SET_USERS_END_DATE,
  payload: date,
});


// Fetch "Favourite Drinks" for Profile Page
export const fetchUserFavouriteDrinks = (userId) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/users/${userId}/favourite-drinks`;
  dispatch({ type: FETCH_FAVOURITE_DRINKS_LOADING });
  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const { data } = response;
    if (data.success) {
      console.log('data', data);
      dispatch({ type: FETCH_FAVOURITE_DRINKS_SUCCESS, payload: data });
    } else {
      dispatch({ type: FETCH_FAVOURITE_DRINKS_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_FAVOURITE_DRINKS_FAIL, payload: errorMessage });
  }
};

// Fetch "Most Repeated Drinks" for Profile Page
export const fetchUserMostRepeatedDrinks = (userId) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/users/${userId}/most-repeated-drinks`;
  dispatch({ type: FETCH_RECENTLY_MOST_REPEATED_DRINKS_LOADING });
  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const { data } = response;
    if (data.success) {
      console.log('data', data);
      dispatch({ type: FETCH_MOST_REPEATED_DRINKS_SUCCESS, payload: data });
    } else {
      dispatch({ type: FETCH_MOST_REPEATED_DRINKS_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_MOST_REPEATED_DRINKS_FAIL, payload: errorMessage });
  }
};

// Fetch "Recently Made Drinks" for Profile Page
export const fetchUserRecentlyMadeDrinks = (userId) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/users/${userId}/recently-made-drinks`;
  dispatch({ type: FETCH_RECENTLY_MADE_DRINKS_LOADING });
  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const { data } = response;
    if (data.success) {
      console.log('data', data);
      dispatch({ type: FETCH_RECENTLY_MADE_DRINKS_SUCCESS, payload: data });
    } else {
      dispatch({ type: FETCH_RECENTLY_MADE_DRINKS_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_RECENTLY_MADE_DRINKS_FAIL, payload: errorMessage });
  }
};

// Fetch "My Crafted Drinks" for Profile Page
export const fetchUserPageMyBar = (userId) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/users/${userId}/my-bar`;
  dispatch({ type: FETCH_PAGE_USER_MYBAR_LOADING });
  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_PAGE_USER_MYBAR_SUCCESS, payload: data });
    } else {
      dispatch({ type: FETCH_PAGE_USER_MYBAR_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_PAGE_USER_MYBAR_FAIL, payload: errorMessage });
  }
};

// Fetch "My Crafted Drinks" for Profile Page
export const fetchUserPageCraftedDrinks = (userId) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/users/${userId}/crafted-drinks`;
  dispatch({ type: FETCH_PAGE_USER_CRAFTEDDRINKS_LOADING });
  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_PAGE_USER_CRAFTEDDRINKS_SUCCESS, payload: data });
    } else {
      dispatch({ type: FETCH_PAGE_USER_CRAFTEDDRINKS_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_PAGE_USER_CRAFTEDDRINKS_FAIL, payload: errorMessage });
  }
};

// Fetch "My Drinks" for Profile Page
export const fetchUserPageDrinks = (userId) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/users/${userId}/my-drinks`;
  dispatch({ type: FETCH_PAGE_USER_DRINKS_LOADING });
  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_PAGE_USER_DRINKS_SUCCESS, payload: data });
    } else {
      dispatch({ type: FETCH_PAGE_USER_DRINKS_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_PAGE_USER_DRINKS_FAIL, payload: errorMessage });
  }
};

//FETCH USERNAME & PHONE
export const fetchUsernameAndPhone = (userId) => async (dispatch) => {
    // console.log("fetchHWSoldInfo action invoked with:",  '?startTime='+startTime+'&endTime='+endTime+'&filter='+filter+'&datefilter='+datefilter+'&country='+country+'&ageStart='+ageStart+'&ageEnd='+ageEnd);
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/users/username-phone`;
    // http://localhost:9890/secureapi/analytics/dashboard/dashboard-user-tile-info?filter=0&table=users&startTime=2023-01-01T00:00:00Z&endTime=2025-12-31T23:59:59Z&agestart=0&ageend=99
    dispatch({ type: FETCH_PAGE_USER_PHONENAME_LOADING });
    // console.log('Running fetchHWSoldInfo ------------------------', apiUrl)
  
    try {

      const token = localStorage.getItem("jwtToken");
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
        params: { userId },
      });
  
    //   console.log("Page USER INFO API Response:", response);
      const { data } = response;
      if (data.success) {
        console.log("///////////// Page USER Info:", data);
        dispatch({ type: FETCH_PAGE_USER_PHONENAME_SUCCESS, payload: data.data });
      } else {
        console.log("H/W Sold Info:", data);
        dispatch({ type: FETCH_PAGE_USER_PHONENAME_FAIL, payload: data.message });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch({ type: FETCH_PAGE_USER_PHONENAME_FAIL, payload: errorMessage });
    }
};

//USER PAGE Info
export const fetchUserPageUserInfo = (startTime, endTime, filter, datefilter, country, ageStart, ageEnd) => async (dispatch) => {
    // console.log("fetchHWSoldInfo action invoked with:",  '?startTime='+startTime+'&endTime='+endTime+'&filter='+filter+'&datefilter='+datefilter+'&country='+country+'&ageStart='+ageStart+'&ageEnd='+ageEnd);
    const table = 'users';
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/users/users-info-v2`;
    // http://localhost:9890/secureapi/analytics/dashboard/dashboard-user-tile-info?filter=0&table=users&startTime=2023-01-01T00:00:00Z&endTime=2025-12-31T23:59:59Z&agestart=0&ageend=99
    dispatch({ type: FETCH_PAGE_USER_INFO_LOADING });
    // console.log('Running fetchHWSoldInfo ------------------------', apiUrl)
  
    try {

      const token = localStorage.getItem("jwtToken");
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
        params: { startTime, endTime, filter, datefilter, country, ageStart, ageEnd, table },
      });
  
    //   console.log("Page USER INFO API Response:", response);
      const { data } = response;
      if (data.success) {
        console.log("///////////// Page USER Info:", data);
        dispatch({ type: FETCH_PAGE_USER_INFO_SUCCESS, payload: data.data });
      } else {
        console.log("H/W Sold Info:", data);
        dispatch({ type: FETCH_PAGE_USER_INFO_FAIL, payload: data.message });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch({ type: FETCH_PAGE_USER_INFO_FAIL, payload: errorMessage });
    }
};

export const fetchUserPageSummaryInfo = (startTime, endTime, filter, datefilter, country, ageStart, ageEnd) => async (dispatch) => {
    // console.log("fetchHWSoldInfo action invoked with:",  '?startTime='+startTime+'&endTime='+endTime+'&filter='+filter+'&datefilter='+datefilter+'&country='+country+'&ageStart='+ageStart+'&ageEnd='+ageEnd);
    const table = 'users';
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/users/users-data-summary`;
    // http://localhost:9890/secureapi/analytics/dashboard/dashboard-user-tile-info?filter=0&table=users&startTime=2023-01-01T00:00:00Z&endTime=2025-12-31T23:59:59Z&agestart=0&ageend=99
    dispatch({ type: FETCH_PAGE_USER_SUMMARY_LOADING });
    // console.log('Running fetchHWSoldInfo ------------------------', apiUrl)
  
    try {
      
      const token = localStorage.getItem("jwtToken");
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
        params: { startTime, endTime, filter, datefilter, country, ageStart, ageEnd, table },
      });
  
    //   console.log("Page USER INFO API Response:", response);
      const { data } = response;
      if (data.success) {
        console.log("///////////// Page USER Summary Info:", data);
        dispatch({ type: FETCH_PAGE_USER_SUMMARY_SUCCESS, payload: data.data });
      } else {
        console.log("User Page Summary Info:", data);
        dispatch({ type: FETCH_PAGE_USER_SUMMARY_FAIL, payload: data.message });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch({ type: FETCH_PAGE_USER_SUMMARY_FAIL, payload: errorMessage });
    }
};

export const fetchUserPageDataPaginated = (
  startTime,
  endTime,
  filter,
  datefilter,
  country,
  ageStart,
  ageEnd,
  page,
  pageSize,
  searchTerm
) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/users/users-data-paginated`;
  
  dispatch({ type: FETCH_PAGE_USERS_PAGINATED_LOADING });
  
  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { 
        startTime, 
        endTime, 
        filter, 
        datefilter, 
        country, 
        ageStart, 
        ageEnd, 
        page, 
        pageSize,
        searchTerm 
      },
    });
    
    const respData = response.data;
    if (respData.success) {
      dispatch({
        type: FETCH_PAGE_USERS_PAGINATED_SUCCESS,
        payload: {
          userdata: respData.data, // the array of paginated records
          totalRegisterUser: respData.totalRegisterUser, // overall count from your API
        },
      });
    } else {
      dispatch({
        type: FETCH_PAGE_USERS_PAGINATED_FAIL,
        payload: respData.message,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "Unexpected error";
    dispatch({
      type: FETCH_PAGE_USERS_PAGINATED_FAIL,
      payload: errorMessage,
    });
  }
};

